
$(window).on("load", function() {
 
//metacard js
//change front page adn back page together
//  change color of text and qr after chaging color
  $('#pplr_tab_1 .pplr-color-select:not(.cstmfy_static) span').on('click', function(e) {

    var color = $(this).data('name');
    if (color == 'White') {
      $('#pplr_tab_3 .pplrgcolor span[data-name="Black"]').trigger('click');
      $('span.pplr-swatch-element.pplrimage[data-val="BLACK QR"]').trigger('click');
    } else {
      $('span.pplr-swatch-element.pplrimage[data-val="WHITE QR"]').trigger('click');
      $('#pplr_tab_3 .pplrgcolor span[data-name="Snow White"]').trigger('click');
    }
    $('.pplr-color-select.cstmfy_static span[data-name="' + color + '"]').trigger('click');
    $('.pplr_tab_index.pplr_active').click();

  });
  
  $('.pplr-wrapper.pplr-checkbox.pplr--qr-[data-main="6"]').on('click',function(e){
    
  });

  $('#next-step').click(function(e) {
      e.preventDefault();
      $('.pplr_active').next().click();
  });
  $('#previous-step').click(function(e) {
      e.preventDefault();
      $('.pplr_active').previous().click();
  });
  $('a.pplr_img').on('click', function(e) {
      e.preventDefault();
  });

  $('.pplefileupload button[type="submit"]').on('click', function(e) {
      if ($('li.pplr_img_w').length < 1) {
          if (!confirm("⚠️ Δεν έχετε προσθέσει το δικό σας Logo, θέλετε σίγουρα να συνεχίσετε χωρίς logo;")) {
              e.preventDefault();
          }
      }
  });


  var step2Click = false;
  var step3Click = false;

  if ($('body').hasClass('pplefileupload')) {
      $('.product-form__buttons > button').hide();
      $('#next-step').show();
  }

  $('.pplr_tab_index').on('click', function() {

      if ($(this).data('tab') == 3 && !step2Click) {
//        $('.pplr-wrapper.pplr-checkbox.pplr--qr-').append('<span id="info-text">ℹ️ Αν δεν θέλετε QR Code θα εμφανίσουμε το logo σας και στις δύο πλευρές.</label>');
          step2Click = true;
      }
      if ($(this).data('tab') == 7 && !step3Click) {
          step3Click = true;
      }
      if ($(this).data('tab') == 7 && $('#label-file-upload').length < 1) {
          $('input.pplr_monogram.fileupload').attr('id', 'file-upload');
          $('.pplrfileuploadbutton').append('<label id="label-file-upload" for="file-upload">Προσθέστε το logo σας</label>');
    
          //$('#pplr_tab_7').append('<span id="info-text">ℹ️ Η προεπισκόπηση είναι ενδεικτική. Ένας γραφίστας θα δει το αίτημά σας και θα το διεκπεραιώσει σύμφωνα με τις προδιαγραφές της κάρτας.</label>');
          $('#pplr_tab_7').append('<span id="info-text">ℹ️ Αν δεν επιλέξετε δικό σας Logo ή design τότε θα εμφανίζεται το METACARD logo.</label>');
          //$('.product__media, .pplr_preview_wrapper.rotate').addClass('rotate');
      } else {
          //$('.product__media, .pplr_preview_wrapper.rotate').removeClass('rotate');
      }
      if (step2Click && step3Click) {
          $('.product-form__buttons > button').show();
          $('#next-step').hide();
          $('#previous-step').show();
      }
  });
  
});

